import { components } from '@kurtosys/ksys-app-components';

import { InjectedStyledComponent } from '../../shared/InjectedStyledComponent';

const Text = components.base.Text.Text;

export default InjectedStyledComponent(Text, 'app', ['commentary']);
